import { termsOfService } from '@/content/policies';

export function useTermsText() {
  return {
    termsText: termsOfService,
  };
}
